// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"110":"6095f8c0","131":"6e286aaa","698":"e00a8342","910":"460c3bc5","984":"6e286aaa"}[chunkId] + ".chunk.css";
};